<script lang="ts" module>
  import { slide } from 'svelte/transition';
  import { tv } from 'tailwind-variants';

  import { BaseBtn } from '@/ui/base';
  import MarkdownText from '@/ui/elements/markdown/MarkdownText.svelte';

  type Dimension = 'expand' | 'white' | 'blue' | 'task';

  export interface InfoCardProps {
    shortText: string;
    longText?: string;
    dimension?: Dimension;
    onClick?: () => void;
  }
</script>

<script lang="ts">
  let { dimension: dimensionProp = 'expand', ...props }: InfoCardProps = $props();
  let contracted = $state(false);

  const styles = tv({
    base: 'grid w-full rounded-sm bg-prim p-3 text-left text-sm',
    variants: {
      dimension: {
        expand: 'bg-prim hocus:bg-prim-H',
        white: 'bg-white',
        blue: 'bg-prim',
        task: 'bg-sec',
      },
    },
  });

  let clickable = $derived(dimensionProp === 'expand');
</script>

<BaseBtn
  class={styles({ dimension: dimensionProp })}
  disabled={!clickable}
  onclick={() => {
    contracted = !contracted;
    props.onClick?.();
  }}
>
  <MarkdownText markdown={props.shortText} />
  {#if !contracted && props.longText}
    <p class="pt-4" transition:slide>
      <strong class="block">Tipp:</strong>
      <MarkdownText markdown={props.longText} />
    </p>
  {/if}
</BaseBtn>
